import { column } from "@podtrac/common/grid";
import styles from "../link-report.module.scss";
import { Elide } from "./elide";

export const creativeColumn = (enableSelect) =>
    column.group({
        header: "Creative",
        columns: [
            column.accessor("creative", {
                id: "Creative",
                header: enableSelect ? "Total" : "",
                cell: CreativeCell,
                meta: { enableSelect },
            }),
        ],
    });

function CreativeCell({
    getValue,
    column: {
        columnDef: {
            meta: { enableSelect },
        },
    },
}) {
    const value = getValue();
    return (
        <div className={styles.flex}>
            {/* TODO: row selection */}
            {enableSelect ? "[ ]" : null}
            <Elide title={value}>{value}</Elide>
        </div>
    );
}
